import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Card from 'reactstrap/lib/Card';
import classnames from 'classnames';
import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';
import { StyledSelect } from 'site-modules/shared/components/styled-select/styled-select';

import './trim-card.scss';

export function TrimAddCard({ removedTrims, onAddTrim, isSticky = false }) {
  const options = removedTrims.map(trim => ({ trim }));

  const onTrimSelect = useCallback(
    ({ trim }) => {
      EventToolbox.fireTrackAction({
        event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
        event_data: {
          action_name: TrackingConstant.ACTION_VIEW_CONTENT,
          creative_id: 'trim-comparator',
          action_category: TrackingConstant.USER_ACTION_CATEGORY,
          action_cause: TrackingConstant.ACTION_CAUSE_LINK_CLICK,
          subaction_name: 'add_trim',
          value: trim,
        },
      });
      onAddTrim(trim);
    },
    [onAddTrim]
  );

  return (
    <Card
      className={classnames(
        'trim-add-card h-100 justify-content-end align-items-center rounded-12 px-1 px-md-0_5 px-lg-1 pt-1',
        {
          'pb-2_5': !isSticky,
          'pb-1': isSticky,
        }
      )}
    >
      <div
        className={classnames('plus d-flex justify-content-center align-items-center bg-blue-90 my-auto', {
          'small-plus': isSticky,
        })}
      >
        <i className="icon-plus3 size-30 text-blue-30" aria-hidden />
      </div>
      <StyledSelect
        onChange={onTrimSelect}
        valueKey="trim"
        labelKey="trim"
        options={options}
        name="trim-comparison-select"
        wrapperClassName="w-100 mt-0_5"
        className="rounded-8 px-1 py-0_5"
        labelClassName="text-cool-gray-50"
        labelText="Add a trim"
        useFloatingLabel
      />
    </Card>
  );
}

TrimAddCard.propTypes = {
  removedTrims: PropTypes.arrayOf(PropTypes.string).isRequired,
  onAddTrim: PropTypes.func.isRequired,
  isSticky: PropTypes.bool,
};
